export default __webpack_public_path__ + "static/media/9d.376b6094.png";